import {
  createCheckboxColumn,
  createColumn,
  createEditableColumn
} from "../components/Table/Table";

export const enumerationLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsEnumeration) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsEnumeration) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    150,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Description",
    (locsEnumeration: Api.LocsEnumeration) => locsEnumeration.description,
    "locsEnumeration.description",
    true,
    undefined,
    undefined,
    "description"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsEnumeration) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    130
  )
];

export const parameterLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    150,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Description",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.description,
    "locsEnumeration.description",
    true,
    undefined,
    undefined,
    "description"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    130
  )
];

export const faultLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsFault) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "Name",
    (locsEnumeration: Api.LocsFault) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    150,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Reason",
    (locsEnumeration: Api.LocsFault) => locsEnumeration.reason,
    "locsEnumeration.reason",
    true,
    undefined,
    undefined,
    "reason"
  ),
  createEditableColumn(
    "Action",
    (locsEnumeration: Api.LocsFault) => locsEnumeration.action,
    "locsEnumeration.action",
    true,
    undefined,
    undefined,
    "action"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsEnumeration) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    100
  )
];

//driveSignalGroupLocalizationStatusColumns
export const driveSignalLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    150,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Description",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.description,
    "locsEnumeration.description",
    true,
    undefined,
    undefined,
    "description"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    100
  )
];

export const driveSignalGroupLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    undefined,
    undefined,
    "text"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsParameter) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    100
  )
];


//Escalator RTD and RTD Group LocalizationStatusColumns:
export const escalatorRTDLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsEscalatorRTD) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsEscalatorRTD) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    150,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Description",
    (locsEnumeration: Api.LocsEscalatorRTD) => locsEnumeration.description,
    "locsEnumeration.description",
    true,
    undefined,
    undefined,
    "description"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsEscalatorRTD) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    100
  )
];

export const escalatorRTDGroupLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsEscalatorRTDGroup) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsEscalatorRTDGroup) => locsEnumeration.text,
    "locsEnumeration.text",
    true,
    undefined,
    undefined,
    "text"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsEscalatorRTDGroup) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    100
  )
];

export const faultCategoryLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsFaultCategory: Api.LocsFaultCategory) => locsFaultCategory.localeNavigation.locale,
    "locsFaultCategory.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "Name",
    (locsFaultCategory: Api.LocsFaultCategory) => locsFaultCategory.text,
    "locsFaultCategory.text",
    true,
    undefined,
    undefined,
    "text"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsFaultCategory: Api.LocsFaultCategory) => locsFaultCategory.needsUpdate,
    "locsFaultCategory.needsUpdate",
    true,
    100
  )
];

//Escalator Event Log LocalizationStatusColumns:
export const escalatorEventLogLocalizationStatusColumns: State.Column[] = [
  createColumn(
    "Locale",
    (locsEnumeration: Api.LocsEscalatorEventLog) => locsEnumeration.localeNavigation.locale,
    "locsEnumeration.localeNavigation.locale",
    true,
    100
  ),
  createEditableColumn(
    "UI Name",
    (locsEnumeration: Api.LocsEscalatorEventLog) => locsEnumeration.text,//CHECK THIS
    "locsEnumeration.text",
    true,
    150,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Description",
    (locsEnumeration: Api.LocsEscalatorEventLog) => locsEnumeration.description,
    "locsEnumeration.description",
    true,
    undefined,
    undefined,
    "description"
  ),
  createCheckboxColumn(
    "Needs update",
    (locsEnumeration: Api.LocsEscalatorEventLog) => locsEnumeration.needsUpdate,
    "locsEnumeration.needsUpdate",
    true,
    100
  )
];
